import { isEmpty } from 'lodash';
import { Dispatch } from 'react';
import { apiBaseUrl, networkCall } from '../../utils/networkCall';

export const GET_DATA: string = "GET_DATA";



export const getData = () => {
    return (dispatch: Dispatch<any>) => {
        networkCall("get", `/whatsapp/templates`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (isEmpty(res.error)) {
                    dispatch({ type: GET_DATA, payload: res });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    console.log(error.response)
                }
            });
    }
}

